import Vue from 'vue'
import Router from 'vue-router'
import Login from '../pages/Login/Login.vue'
import Home from '../pages/Home/Home.vue'
import UserList from '../pages/UserManage/UserList.vue'
import UserInfo from '../pages/UserManage/UserInfo.vue'
import UserInfoGame from '../pages/UserManage/UserInfoGame.vue'
import UserInformation from '../pages/UserManage/UserInformation.vue'
import GameManage from '../pages/GameManage/GameManage.vue'
import GameInfo from '../pages/GameManage/GameInfo.vue'
import GameInfoUser from '../pages/GameManage/GameInfoUser.vue'


import ArticleList from '../pages/ArticleManage/ArticleList.vue'
import ArticleAdd from '../pages/ArticleManage/ArticleAdd.vue'
import ArticleEdit from '../pages/ArticleManage/ArticleEdit.vue'
import TestRecord from '../pages/TestRecord/TestRecord.vue'
import TestInfo from '../pages/TestRecord/TestInfo.vue'
import TestList from '../pages/TestAdd/TestList.vue'
import TestAdd from '../pages/TestAdd/TestAdd.vue'
import TestEdit from '../pages/TestAdd/TestEdit.vue'
import ArticleVariety from '../pages/ArticleVariety/ArticleVariety.vue'
import TestVariety from '../pages/TestVariety/TestVariety.vue'
import EvaluationList from '../pages/SportsEvaluation/EvaluationList.vue'
import userDataEachars from "../pages/UserDataAnalyze/UserDataEachars.vue";
import CommunityManagement from "../pages/CommunityManagement/CommunityManagement.vue";
import CommunityAdd from "../pages/CommunityManagement/CommunityAdd.vue";
import CityLookAndRevise from "../pages/CityManage/CityLookAndRevise.vue";
import CityGroupAdd from "../pages/CityManage/CityGroupAdd.vue";
import ShareClicksNumber from "../pages/ShareClicksNumber/ShareClicksNumber.vue";
import AddGame from "../pages/GameManage/AddGame.vue";

// 用户记录
// import UserRecord from "../pages/userRecord/UserRecord.vue"
import playRecord from "../pages/userRecord/playRecord/playRecord.vue" // 播放记录
import maintenanceData from "../pages/maintenanceData/maintenanceData.vue" // 播放记录
import userOrder from "../pages/UserManage/userOrder.vue" // 订单记录
import userRebate from "../pages/UserManage/userRebate.vue" // 订单记录
import OrderList from "../pages/OrderCenter/OrderList.vue" // 订单列表
import OrderDetail from "../pages/OrderCenter/OrderDetail.vue" // 订单详情
import SalesRefund from "../pages/OrderCenter/SalesRefund.vue" // 售后退款
import FinancialStatistics from "../pages/FinanceManage/FinancialStatistics.vue" // 财务统计
import taskData from "../pages/taskData/taskData.vue" // 任务列表
import yesterdayReport from "../pages/yesterdayReport/yesterdayReport.vue" // 
import bEnd from "../pages/B-end/B-end.vue" // 
import BAccountRegistration from '../pages/BAccountRegistration/BAccountRegistration.vue'
import deBug from '../pages/deBug/deBug.vue'
import userTaskPage from '../pages/UserManage/userTaskPage.vue'
import userGrouping from '../pages/user_grouping/user_grouping.vue'
import user_grouping_details from '../pages/user_grouping/user_grouping_details.vue'
import userGroupDetails from '../pages/UserManage/userGroupDetails.vue'
import groupTasks from '../pages/user_grouping/group-tasks.vue'
import userGroupTask from '../pages/user_task_list/user_group_task/user_group_task.vue'
import userTask from '../pages/user_task_list/user_task/user_task.vue'
import themeDialogue from '../pages/theme-Dialogue/theme-Dialogue.vue'
import themeDialogueScore from '../pages/theme-Dialogue/theme-Dialogue-score/theme-Dialogue-score.vue'

const G = require('./../../global');
const routerPush = Router.prototype.push;
//解决相同路径跳转报错
Router.prototype.push = function push(location) {
  return routerPush.call(this, location).catch(error => error)
};
Vue.use(Router);

export default new Router({
  // mode: 'history',
  //打包时添加base,如果网址在跟目录下则base='/'，如果为子路径，则base='子路径名称'
  base: process.env.NODE_ENV === 'production' ? G.publicPath + '/' : '/',

  routes: [
    {
      //登录
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      //首页
      path: '/',
      name: 'user',
      component: UserList
    },
    {
      //用户管理>用户详情
      path: '/user-info',
      component: UserInfo,
    },
    {
      //用户管理>用户详情>游戏详情
      path: '/user-info/game',
      component: UserInfoGame,
    },
    {
      //用户管理>用户基本资料
      path: '/user-information',
      component: UserInformation,
    },
    {
      //游戏管理
      path: '/game-manage',
      component: GameManage
    },
    {
      //游戏管理>详情
      path: '/game-manage/info',
      component: GameInfo,
    },
    {
      //游戏管理>详情>用户记录
      path: '/game-manage/info/user',
      component: GameInfoUser,
    },
    {
      //游戏管理>详情
      path: '/game-manage/add-game',
      component: AddGame,
    },
    {
      //文章列表
      path: '/article-list',
      component: ArticleList
    },
    {
      //文章添加
      path: '/article-add',
      component: ArticleAdd
    },
    {
      //文章添加
      path: '/article-edit',
      component: ArticleEdit
    },
    {
      //答题记录
      path: '/test-record',
      component: TestRecord
    },
    {
      //答题记录>详情
      path: '/test-info',
      component: TestInfo
    },
    {
      //问卷列表
      path: '/test-list',
      component: TestList
    },
    {
      //问卷列表>添加
      path: '/test-add',
      component: TestAdd
    },
    {
      //问卷列表>编辑
      path: '/test-edit',
      component: TestEdit
    },
    {
      //文章分类
      path: '/article-variety',
      component: ArticleVariety
    },
    {
      //问卷分类
      path: '/test-variety',
      component: TestVariety
    },
    {
      //运动测评列表
      path: '/evaluation-list',
      component: EvaluationList
    },
    {
      //用户详细信息的大数据
      path: '/user-data-eachars',
      component: userDataEachars
    },
    {
      //用户详细信息的大数据
      path: '/community-management',
      component: CommunityManagement
    },
    {
      //用户详细信息的大数据
      path: '/community-add',
      component: CommunityAdd
    },
    {
      //群的省份的添加
      path: '/city-look-and-revise',
      component: CityLookAndRevise
    },
    {
      //群的省份的添加
      path: '/city-group-add',
      component: CityGroupAdd
    },
    {
      //群的省份的添加
      path: '/share-clicks-number',
      component: ShareClicksNumber
    },
    // {
    //   // 用户记录
    //   path: '/user-record',
    //   component: UserRecord
    // },
    {
      // 用户记录
      path: '/play-record',
      component: playRecord,

    },
    {
      // 用户记录
      path: '/maintenance-data',
      component: maintenanceData,
    },
    {
      // 用户订单
      path: '/userOrder',
      component: userOrder,
    },
    {
      // 订单中心-订单列表
      path: '/order-list',
      component: OrderList,
    },
    {
      // 订单中心-订单详情
      path: '/order-detail',
      component: OrderDetail,
    },
    {
      // 订单中心-售后退款
      path: '/sales-refund',
      component: SalesRefund,
    },
    {
      // 财务管理-财务统计
      path: '/financial-statistics',
      component: FinancialStatistics,
    },
    {
      // 任务列表
      path: '/taskData',
      component: taskData,
    },
    {
      // 昨日报告
      path: '/yesterdayReport',
      component: yesterdayReport,
    },
    {
      // B端数据
      path: '/bEnd',
      component: bEnd,
    },
    {
      // 返现数据
      path: '/userRebate',
      component: userRebate,
    },
    {
      // B端账户注册
      path: '/BAccountRegistration',
      component: BAccountRegistration,
    },
    {
      // B端账户注册
      path: '/deBug',
      component: deBug,
    },
    {
      // 用户任务列表
      path: '/userTaskPage',
      component: userTaskPage,
    },
    {
      // 用户分组
      path: '/userGrouping',
      component: userGrouping,
    },
    {
      // 用户分组详情
      path: '/user_grouping_details',
      component: user_grouping_details,
    },
    {
      // 用户分组查看
      path: '/userGroupDetails',
      component: userGroupDetails,
    },
    {
      // 用户分组任务
      path: '/groupTasks',
      component: groupTasks,
    },
    {
      // 用户分组任务
      path: '/userGroupTask',
      component: userGroupTask,
    },
    {
      // 用户分组任务
      path: '/userTask',
      component: userTask,
    },
        {
      // 主题对话
      path: '/themeDialogue',
      component: themeDialogue,
    },
        {
      // 主题对话情绪打分
      path: '/themeDialogueScore',
      component: themeDialogueScore,
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js